import config from '../config'

export const getCookie = (name) => {
  const value = '; ' + document.cookie
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}

export const setCookie = (cookie, value, domain, path) => {
  const cookieDomain = domain || config.cookieDomain
  const cookiePath = path || '/'

  document.cookie = `${cookie}=${value}; path=${cookiePath}; domain=${cookieDomain};`
}

export const getGAClientId = () => {
  const GA_CLIENT_ID_COOKIE_KEY = '_ga'

  const gaCookie = getCookie(GA_CLIENT_ID_COOKIE_KEY)

  if (gaCookie) {
    const [clientId] = gaCookie.match(/\d+\.\d+$/)

    return clientId
  }

  return null
}
